<template>
    <div class="profile-container">
      <div class="header">
        <div class="user-info">
          <img class="user-avatar" :src="userAvatar" alt="User avatar">
          <h1 class="user-name">{{ userName }}</h1>
          <p class="user-detail">还剩50瓶啤酒未消费</p>
          <button class="edit-button">编辑</button>
        </div>
      </div>
      <!-- <div class="profile-options"> -->
        <!-- 选项列表 -->
        <!-- <div class="option-item"> -->
          <!-- <i class="icon chat-icon"></i> -->
          <!-- 消息 -->
        <!-- </div> -->
        <!-- <div class="option-item">
          <i class="icon mail-icon"></i>
          邮箱
        </div> -->
        <!-- 其他选项 -->
      <!-- </div> -->
      <!-- 底部导航 -->
      <div class="footer-nav">
        <div class="nav-item active">
          <i class="icon home-icon"></i>
          消费记录
        </div>
        <div class="nav-item">
          <i class="icon contact-icon"></i>
          消息
        </div>
        <!-- 其他导航项 -->
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      userName: String,
      userWechat: String,
      userAvatar: String
    },
    data() {
      return {
        // 其他数据
      };
    },
    methods: {
      // 事件处理函数
    }
  };
  </script>
  
  <style scoped>
  .profile-container {
    font-family: 'Arial', sans-serif;
  }
  
  .header {
    background-color: #f0f0f0;
    padding: 16px;
    text-align: center;
  }
  
  .user-info {
    display: inline-block;
    text-align: left;
  }
  
  .user-avatar {
    width: 70px;
    height: 70px;
    border-radius: 50%;
  }
  
  .user-name {
    margin: 8px 0;
  }
  
  .user-detail {
    color: gray;
  }
  
  .edit-button {
    background-color: #ffffff;
    border: 1px solid #dddddd;
    border-radius: 5px;
    padding: 5px 10px;
    margin-top: 8px;
  }
  
  .profile-options {
    background-color: #ffffff;
    margin-top: 10px;
  }
  
  .option-item {
    padding: 10px;
    border-bottom: 1px solid #eaeaea;
  }
  
  .icon {
    /* 在这里添加图标的样式 */
  }
  
  .footer-nav {
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-around;
    background-color: #f0f0f0;
  }
  
  .nav-item {
    padding: 10px;
    text-align: center;
  }
  
  .nav-item.active {
    color: green;
  }
  
  /* 在这里添加更多样式 */
  </style>
  


// WEBPACK FOOTER //
// src/UserProfile.vue